import { Component, inject, input } from '@angular/core';
import { LpStoryActivity } from '@typings/lp/generated';
import { LpMissionService } from '../lp-mission/lp-mission.service';
import { LpStoryComponent } from '../lp-story/lp-story.component';

@Component({
  selector: 'lp-story-activity',
  imports: [LpStoryComponent],
  templateUrl: './lp-story-activity.component.html',
  styleUrl: './lp-story-activity.component.css',
})
export class LpStoryActivityComponent {
  readonly #lpMissionService = inject(LpMissionService);

  storyActivity = input.required<LpStoryActivity>();

  async finish() {
    await this.#lpMissionService.finishActivity(this.storyActivity());
  }
}
